/**
 * Fabric.js v5 is CommonJS. Normalize whatever Vite exposes into the
 * classic `fabric` namespace (`fabric.Canvas`, etc.).
 */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore — runtime shape varies under Vite CJS interop
import fabricImport from 'fabric';

type FabricNS = typeof import('fabric').fabric;

function resolveFabric(mod: unknown): FabricNS {
  if (!mod || typeof mod !== 'object') {
    throw new Error('Fabric.js module failed to load');
  }

  const m = mod as Record<string, unknown>;

  // Named export: { fabric: { Canvas, ... } }
  if (m.fabric && typeof (m.fabric as { Canvas?: unknown }).Canvas === 'function') {
    return m.fabric as FabricNS;
  }

  // Default is the namespace itself: { Canvas, ... }
  if (typeof m.Canvas === 'function') {
    return m as unknown as FabricNS;
  }

  // Default wraps fabric: { default: { fabric } } or { default: { Canvas } }
  const d = m.default as Record<string, unknown> | undefined;
  if (d) {
    if (d.fabric && typeof (d.fabric as { Canvas?: unknown }).Canvas === 'function') {
      return d.fabric as FabricNS;
    }
    if (typeof d.Canvas === 'function') {
      return d as unknown as FabricNS;
    }
  }

  throw new Error('Fabric.js loaded but Canvas constructor was not found');
}

const fabric = resolveFabric(fabricImport);

export default fabric;
export { fabric };
